export function formatTime (time) {
  const hours = pad(time.getUTCHours(), 2)
  const minutes = pad(time.getUTCMinutes(), 2)
  const seconds = pad(time.getUTCSeconds(), 2)
  const milliseconds = pad(time.getUTCMilliseconds(), 3)

  return `${hours}:${minutes}:${seconds}.${milliseconds}`
}

function pad (num, size) {
  return ('000' + num).slice(size * -1)
}



// WEBPACK FOOTER //
// ./src/components/MetaList/lib/utils.js